<!-- App Main Structure -->
<template>
    <div class="app-default-layout">
        <template v-if="loading">
            <rotate-square2></rotate-square2>
        </template>
        <template v-else>
            <!-- App Header -->
            <app-header></app-header>
            <!-- App Main Content -->
            <v-content>
                <!-- App Router -->
                <transition
                    name="router-anim"
                    :enter-active-class="`animated ${selectedRouterAnimation}`"
                >
                    <router-view></router-view>
                </transition>
            </v-content>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from 'Components/Header/Header.vue'
import AppConfig from 'Constants/AppConfig'

import {
    emails_group_it,
    emails_group_special,
} from '@/assets/jsondata/auth_list.json'

export default {
    data() {
        return {
            loading: true,
        }
    },
    components: {
        appHeader: Header,
    },
    computed: {
        ...mapGetters(['selectedRouterAnimation']),
    },
    async beforeCreate() {
        const defualtPath = '/admin/widget/voice-of-stakeholder/123.1'
        const defualtPathAD = '/admin/widget/caats/141.3'
        const isLoggedIn = (await this.$store.getters.isLoggedin) || false
        const userInfo = (await this.$store.getters.getUser) || null
        let levelAD =
            userInfo !== null && typeof userInfo.department !== 'undefined'
                ? userInfo.department.level
                : null
        levelAD =
            levelAD !== null
                ? levelAD.match(/[\d]+$/gi) !== null &&
                  typeof levelAD.match(/[\d]+$/gi)[0] !== 'undefined'
                    ? parseInt(levelAD.match(/[\d]+$/gi)[0])
                    : 0
                : 0

        // check user is not log in
        if (userInfo.email !== 'admin@me.com') {
            if (!isLoggedIn && Object.keys(userInfo).length == 0) {
                this.$router.push('/admin/login')
            } else {
                if (userInfo.type == 'ad_auth') {
                    if (
                        levelAD >= 9 ||
                        emails_group_it.includes(userInfo.email) ||
                        emails_group_special.includes(userInfo.email)
                    ) {
                        this.$router.push(defualtPath)
                    } else {
                        this.$router.push(defualtPathAD)
                    }
                } else {
                    this.$router.push(defualtPath)
                }
            }
        } else {
            if (this.$route.path.match(/\/admin\/dashboard/gi)) {
                this.$router.push(defualtPath)
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.loading = false
        }, 1000)
    },
}
</script>

<style scoped>
.app-default-layout {
    height: 100vh;
}
</style>
